import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import logoPSA from '../../../assets/logos/PSA-White.png'
import logoCGC from '../../../assets/logos/CGC-Black.png'
import logoAGS from '../../../assets/logos/AGS-Black.png'
import logoNFL from '../../../assets/logos/NFL-White.png'
import logoPokemon from '../../../assets/logos/Pokemon-White.png'
//import logoAlien from '../../../assets/Alien-Black.png'

function cardWalls() {
    return (
        <Col sm={10} md={2} lg={6} xl={6} className='DashCardWallNewestPadding'>
            <Col className='shadow-lg'>
                <Row className='d-flex align-items-center justify-content-center'>
                    <Col>
                        <Link to='/dashboard/card-wall/graded/psa'><img
                            src={logoPSA}
                            alt="PSA Logo"
                            height="50"
                        /></Link>
                    </Col>
                    <Col>
                        <Link to='/dashboard/card-wall/graded/cgc'><img
                            src={logoCGC}
                            alt="CGC Logo"
                            height="50"
                        /></Link>
                    </Col>
                    <Col>
                        <Link to='/dashboard/card-wall/graded/ags'><img
                            src={logoAGS}
                            alt="AGS Logo"
                            height="48"
                        /></Link>
                    </Col>
                </Row>
                <Row className='d-flex align-items-center justify-content-center'>
                    <Col>
                        <Link to='/dashboard/card-wall/game/football'><img
                            src={logoNFL}
                            alt="NFL Logo"
                            height="50"
                        /></Link>
                    </Col>
                    <Col>
                        <Link to='/dashboard/card-wall/game/pokemon'><img
                            src={logoPokemon}
                            alt="Pokemon Logo"
                            height="50"
                        /></Link>
                    </Col>
                </Row>
            </Col>
        </Col>
    )
}

export default cardWalls